import LockDeskService from '@/services/v2/pricingEngine/lockDesk.service';

export const lockDesk = {
  namespaced: true,
  state: {
    isLockDeskAdmin: false,
  },
  getters: {
    isLockDeskAdmin: state => state.isLockDeskAdmin,
  },
  mutations: {
    setIsLockDeskAdmin(state, value) {
      state.isLockDeskAdmin = value;
    },
  },
  actions: {
    checkLockDeskAdmin({ commit }) {
      return LockDeskService.checkLockDeskAdmin().then(response => {
        if (response.status === 200) {
          commit('setIsLockDeskAdmin', true);
        } else {
          commit('setIsLockDeskAdmin', false);
        }
      }).catch(() => {
        commit('setIsLockDeskAdmin', false);
      });
    },
  }
};

export default lockDesk;